export const apiListAndData = {
    // Fetch initial table data when the component mounts for the first time
    getInitialTableDetails: {
        // url: 'rms/properties/otbx/{pid}/?includeSellRate=false&segment=true&asOfDate={asOfDate}&fromDate={fromDate}&toDate={toDate}',
        url: '/users/check-login',
        name: 'getInitialTableDetails',
        data: {},
        status: '',
        timestamp: null
    },

    // Fetch detailed data for a specific date when a user selects a date
    getDateRestrictionDetails: {
        url: 'rms/properties/restrictions/products/details/{pid}/?asOfDate={asOfDate}',
        name: 'getDateRestrictionDetails',
        data: {},
        status: '',
        timestamp: null
    },

    getDateRestrictionStatusDetails: {
        url: 'rms/properties/restrictions_status/products/details/{pid}/?asOfDate={asOfDate}',
        name: 'getDateRestrictionStatusDetails',
        data: {},
        status: '',
        timestamp: null
    },

    // Retrieve the updated threshold value for a specific date based on provided input
    getThreshholdValue: {
        url: '/users/test',
        name: 'getThreshholdValue',
        data: {},
        status: '',
        timestamp: null
    },

    // Apply updated recommendations and restrictions for the selected date range
    thresholdToggle: {
        url: '/rms/properties/restrictions/products/details/{pid}/',
        name: 'allThreshholdApply',
        data: {},
        status: '',
        timestamp: null
    },

    overrideRequest: {
        url: 'rms/properties/restrictions/products/details/{pid}/?asOfDate={asOfDate}',
        name: 'overrideRequest',
        data: {},
        status: '',
        timestamp: null
    },

    /** CART API's */
    getInitialCartTableDetails: {
        url: 'rms/properties/restrictions/products/cart/{pid}/?asOfDate={asOfDate}&actionType=datesOnly',
        name: 'getInitialCartTableDetails',
        data: {},
        status: '',
        timestamp: null
    },

    getCartDateDetails: {
        url: 'rms/properties/restrictions/products/cart/{pid}/?asOfDate={asOfDate}&actionType=stayDate',
        name: 'getInitialCartTableDetails',
        data: {},
        status: '',
        timestamp: null
    },

    singleDateDelete: {
        url: 'rms/properties/restrictions/products/cart/{pid}/',
        name: 'singleDateDelete',
        data: {},
        status: '',
        timestamp: null
    },

    clearCart: {
        url: 'rms/properties/restrictions/products/{pid}/',
        name: 'clearCart',
        data: {},
        status: '',
        timestamp: null
    },

    getDateRestrictionsLogs: {
        url: 'rms/properties/restrictions/products/status/{pid}/?asOfDate={asOfDate}&fromDate={fromDate}&toDate={toDate}',
        name: 'getDateRestrictionsLogs',
        data: {},
        status: '',
        timestamp: null
    },


    // Modal 1 pricing API list
    getModal1PricingInitalData: {
        url: 'users/check-login',
        name: 'getModal1PricingInitalData',
        data: {},
        status: '',
        timestamp: null
    },

    // Portfolio Settings 
     getUserPortfolio: {
        url: 'rms/user-portfolio/portfolios/',
        name: 'getUserPortfolio',
        data: {},
        status: '',
        timestamp: null
    },

    // Save user columns preferences 
    saveUserColumnPreferences: {
        url: 'users/column-preference/',
        name: 'saveUserColumnPreferences',
        data: {},
        status: '',
        timestamp: null
    }


};